import { ProductPropertyType } from "../api/models/ProductProperty";
import { TaxonomyElement } from "../api/models/TaxonomyElement";

export abstract class SearchFilter{
    id : string;
    value: string | number;
    field: string = ''
    type: ProductPropertyType = "https://qmo.com/Facet/discrete"

    constructor(id: string, value: string | number){
        this.id = id
        this.value = value
    }

    toSolrFilter(): {[field: string]: string[]} {
        let result: {[field: string]: string[]} = {}
        result[this.field] = []
        result[this.field].push(this.id)
        return result
    }
}

export class CategoryFilter extends SearchFilter{
    field: string = 'category'
    count: number
    taxonomyReference: TaxonomyElement | null

    constructor(categoryId: string, categoryLabel: string, count: number = 0, taxonomyReference: TaxonomyElement | null ){
        super(categoryId, categoryLabel)
        this.count = count
        this.taxonomyReference = taxonomyReference
    }
}

export class PropertyFilter extends SearchFilter{
    field: string = 'property_option'
    count: number
    propId: string
    constructor(id:string, propId: string, optionValue: string | number, optionType: ProductPropertyType, count: number = 0 ){
        super(id, optionValue)
        this.type = optionType
        this.propId = propId
        this.count = count
    }
}

export const ANY_PROP_OPTION: string = 'Any'
export const UNSET_PROP_OPTION: string = 'Unset'